import { isNullOrWhitespace } from './stringHelper';

export function isValidUrl(string?: string | null) {
  if (isNullOrWhitespace(string)) {
    return false;
  }
  try {
    new URL(string as string);
  } catch (_) {
    return false;
  }

  return true;
}

export function getActiveTabFromNav(isSubTab?: boolean) {
  const urlParams = new URLSearchParams(window.location.search);
  const activeTab = urlParams.get(isSubTab ? 'activeSubTab' : 'activeTab');
  return String(activeTab || '0_0');
}
